module.exports = __webpack_public_path__ + "img/20161025_005347.489ccac0.jpg";